/**
 * Trophy Chase TCG Theme
 * General theme utilities and helpers
 */

(function() {
  'use strict';

  /**
   * Initialize theme on DOM ready
   */
  function init() {
    console.log('Trophy Chase TCG theme loaded');

    // Add any general theme initialization here
    handleExternalLinks();
    handleSmoothScroll();
  }

  /**
   * Open external links in new tab
   */
  function handleExternalLinks() {
    const links = document.querySelectorAll('a[href^="http"]');
    links.forEach(link => {
      if (!link.href.includes(window.location.hostname)) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  /**
   * Smooth scroll for anchor links
   */
  function handleSmoothScroll() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href && href !== '#') {
          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
